import type { InspectionType } from "@/mocks/configuracoes";

interface InspectionTypesTableProps {
  types: InspectionType[];
}

export default function InspectionTypesTable({ types }: InspectionTypesTableProps) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-background-200">
            <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Tipo de vistoria</th>
            <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Periodicidade sugerida</th>
            <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Campos obrigatórios</th>
            <th className="text-center py-3 px-3 text-xs font-medium text-foreground-500">Exige foto</th>
            <th className="text-center py-3 px-3 text-xs font-medium text-foreground-500">Ativo</th>
            <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Ações</th>
          </tr>
        </thead>
        <tbody>
          {types.map((t) => (
            <tr key={t.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
              <td className="py-2.5 px-3 text-foreground-900 font-medium">{t.name}</td>
              <td className="py-2.5 px-3 text-foreground-600 text-xs">{t.suggestedFrequency}</td>
              <td className="py-2.5 px-3">
                <div className="flex flex-wrap gap-1">
                  {t.requiredFields.slice(0, 3).map((f, i) => (
                    <span key={i} className="inline-flex px-1.5 py-0.5 rounded bg-secondary-50 text-secondary-700 text-xs">{f}</span>
                  ))}
                  {t.requiredFields.length > 3 && <span className="text-xs text-foreground-400">+{t.requiredFields.length - 3}</span>}
                </div>
              </td>
              <td className="py-2.5 px-3 text-center">
                {t.requiresPhoto ? <i className="ri-check-line text-primary-600 text-base" /> : <i className="ri-close-line text-foreground-300 text-base" />}
              </td>
              <td className="py-2.5 px-3 text-center">
                <span className={`inline-flex w-2.5 h-2.5 rounded-full ${t.active ? "bg-primary-500" : "bg-foreground-300"}`} />
              </td>
              <td className="py-2.5 px-3">
                <button className="w-8 h-8 rounded-lg hover:bg-background-100 flex items-center justify-center text-foreground-400 hover:text-primary-600 transition-colors" title="Editar">
                  <i className="ri-edit-line text-sm" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}